import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import RenderTextField from '../../../utils/renderFields/RenderTextField';
// import AdressAutocomplete from '../../../utils/AdressAutocomplete';

import { createCourse, closeDrawer, addCommands } from '../courseActions';
import validate from './validate';

const Title = styled.h1``;

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  },
  button: {
    margin: theme.spacing(7)
  },
  form: {
    marginTop: 50
  }
}));

/**
 * Drawer permettant de faire une demande de coursier
 * ou d'ajouter des commandes à une course en cours
 * @param {Function}  handleSubmit      Crée une course ou ajoute des commandes à une course en cours
 * @param {Object}  currentCourse       Objet contenant les informations de la course en cours
 * @param {Boolean} isOpen              Statut du drawer ouver ou fermer
 * @param {Function}  dispatchCloseDrawer Fermeture du drawer
 */
let CourseDrawer = ({
  handleSubmit,
  currentCourse,
  isOpen,
  dispatchCloseDrawer
}) => {
  const classes = useStyles();
  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      onOpen={() => null}
      onClose={() => {
        dispatchCloseDrawer();
      }}
      open={isOpen}
    >
      <div style={{ padding: 20 }}>
        <Title>
          {currentCourse
            ? 'Ajouter des commandes à la course en cours'
            : 'À quelle adresse notre coursier doit-il récupérer vos commandes'}
        </Title>
        <form className={classes.form} onSubmit={handleSubmit} noValidate>
          {/*
            <Grid container justify="center" spacing={7}>
              <Grid item md={12}>
                <AdressAutocomplete />
              </Grid>
            </Grid>
          */}
          <Grid container justify="center" spacing={7}>
            <Grid item md={6}>
              <Field
                name="street"
                label="Rue"
                disabled={!!currentCourse}
                component={RenderTextField}
                fullWidth
                type="text"
              />
            </Grid>
            <Grid item md={6}>
              <Field
                name="city"
                label="Ville"
                disabled={!!currentCourse}
                component={RenderTextField}
                fullWidth
                type="text"
              />
            </Grid>
            <Grid item md={6}>
              <Field
                name="postalCode"
                label="Code postal"
                disabled={!!currentCourse}
                component={RenderTextField}
                fullWidth
                type="text"
              />
            </Grid>
            <Grid item md={6}>
              <Field
                name="complement"
                label="Complément"
                disabled={!!currentCourse}
                component={RenderTextField}
                fullWidth
                type="text"
              />
            </Grid>
          </Grid>
          <Grid container justify="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              type="submit"
            >
              {currentCourse ? 'Ajouter' : 'Valider'}
            </Button>
          </Grid>
        </form>
      </div>
    </SwipeableDrawer>
  );
};

const mapStateToProps = state => {
  const { currentCourse } = state.init;
  if (currentCourse) {
    if (currentCourse.city) {
      const {
        city,
        complement,
        postalCode,
        street,
        street2
      } = currentCourse.pickupAddress;
      return {
        initialValues: {
          city,
          complement,
          postalCode,
          street,
          street2
        },
        currentCourse,
        checkedCommandsIds: state.commands.checkedCommandsIds,
        isOpen: state.course.openDrawer
      };
    }
  }
  return {
    currentCourse,
    checkedCommandsIds: state.commands.checkedCommandsIds,
    allCommands: state.course.allCommands,
    isOpen: state.course.openDrawer
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchCloseDrawer: () => dispatch(closeDrawer())
});

CourseDrawer = reduxForm({
  form: 'courseForm',
  validate,
  onSubmit: (values, dispatch, props) => {
    const commands = props.checkedCommandsIds.map(commandId => ({
      id: commandId
    }));
    if (props.allCommands && props.currentCourse) {
      return dispatch(
        addCommands({
          id: props.currentCourse.id,
          commandsStates: ['draft']
        })
      );
    }
    if (props.allCommands) {
      return dispatch(
        createCourse({
          pickupAddress: {
            ...values,
            countryCode: 'FR'
          },
          commandsStates: ['draft']
        })
      );
    }
    if (props.currentCourse) {
      return dispatch(
        addCommands({
          commands,
          id: props.currentCourse.id
        })
      );
    }
    return dispatch(
      createCourse({
        pickupAddress: {
          ...values,
          countryCode: 'FR'
        },
        commands
      })
    );
  }
})(CourseDrawer);

CourseDrawer.propTypes = {
  handleSubmit: PropTypes.func,
  dispatchCloseDrawer: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  currentCourse: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseDrawer);
